import { NoDataFound } from '@fabric-ui/components';
import NoViolationsFound from '@fabric-ui/icons/svg/emptyStates/NoViolationsFound.svg';
import { flex, refetchingStyle } from '@fabric-ui/theme';
import { Box, Button } from '@mui/material';
import { useNavigate } from '@utils/AvRouter';
import Pluralize from 'pluralize';
import { PAGE_PATHS } from '../../types';

export const violationTicketsNoDataFound = ({ projDisplayName, isRefetching }) => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate({ to: `../${PAGE_PATHS.POLICIES}/create` });
  };

  return (
    <NoDataFound
      headline={`No ${Pluralize(projDisplayName)} Found`}
      img={NoViolationsFound}
      style={isRefetching ? { containerStyle: refetchingStyle } : {}}
      callToAction={
        <Box sx={flex.colStartCenter}>
          <Box sx={{ ...flex.justifyStartCenter }}>
            <Button onClick={handleNavigate}>Create a policy</Button> to get started.
          </Box>
          If violations occur, they will be grouped into tickets here
        </Box>
      }
    />
  );
};
